import { range } from "lodash";
import React, { useState } from "react";
import { Row } from "@/shared/ui/Blocks";
import { cn } from "@/shared/utils/shadcn";
import { ScoreRangeInput } from "./ScoreRangeInput";
import { useFeatureFlag } from "@/shared/hooks/useFeatureFlag";
import { FeatureFlagKey } from "@/types/feature-flags";

interface DefaultScoreInputProps {
  value?: number;
  allowEmpty?: boolean;
  maxScore?: number;
  onChange?: (value: number) => void;
}

function ScoringInput(props: DefaultScoreInputProps) {
  const isFourPointScoring = useFeatureFlag(FeatureFlagKey.FOUR_POINT_SCORING);
  const defaultMaxScore = isFourPointScoring ? 4 : 5;
  const {
    onChange,
    value,
    maxScore = defaultMaxScore,
    allowEmpty = true,
  } = props;

  const [scoreValue, setScoreValue] = useState(value);

  const scoreRange = range(allowEmpty ? 0 : 1, maxScore + 1);

  const handleScoreChange =
    (score?: number) => (event: React.MouseEvent<HTMLButtonElement>) => {
      setScoreValue(score);
      if (score === undefined) return;
      onChange?.(score);
      event.stopPropagation();
    };

  return (
    <Row className="gap-x-2">
      {scoreRange.map((score) => {
        const isSelected = score === scoreValue;

        return (
          <button
            key={score?.toString()}
            className={cn(
              "w-8 h-8 rounded-full border border-grey-300 border-solid text-sm text-grey-700 font-medium transition-all hover:border-blue-500",
              isSelected && "border-blue-500 bg-blue-500 text-white"
            )}
            onClick={handleScoreChange(score)}
          >
            {score === 0 ? "-" : score}
          </button>
        );
      })}
    </Row>
  );
}

export { ScoringInput, ScoreRangeInput };
